export default __webpack_public_path__ + "static/media/eye-close.60438aab.svg";